import React, { useState } from 'react';
import { email as emailRegex } from 'magic-tricks/lib/regex';
import cx from 'classnames';
import xss from 'xss';

const NavNewsletter = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [state, setState] = useState({
        email: null,
        isSuccess: false,
        isError: false,
        isSubmitting: false,
        showInvalidEmailError: false,
    });

    const onChangeEmail = event => {
        const { showInvalidEmailError } = state;
        setState({
            ...state,
            email: xss(event.target.value),
            showInvalidEmailError: showInvalidEmailError
                ? !emailRegex.test(event.target.value)
                : showInvalidEmailError,
        });
    };

    const handleSubmit = async event => {
        event.preventDefault();

        if (!state.email) {
            setState({
                ...state,
                showInvalidEmailError: false,
                isSubmitting: false,
                isError: 'Please enter your email.',
            });
            return;
        }

        if (!emailRegex.test(state.email)) {
            setState({
                ...state,
                showInvalidEmailError: true,
                isError: false,
                isSubmitting: false,
            });

            return;
        }

        setState({
            ...state,
            isSubmitting: true,
            isError: false,
            showInvalidEmailError: false,
        });

        fetch('.netlify/functions/email', {
            method: 'POST',
            body: JSON.stringify({
                email: state.email,
            }),
        })
            .then(res => {
                return res.json();
            })
            .then(response => {
                if (response.success) {
                    setState({
                        ...state,
                        isError: null,
                        isSuccess: 'Thank you for signing up!',
                    });
                }
            })
            .catch(error => {
                console.error(error);
                setState({
                    ...state,
                    isError:
                        'Uh oh. Something went wrong. Please try again later.',
                });
            });
    };

    return (
        <div
            className={cx('newsletter--nav pf bg--beige tl', {
                active: isOpen,
            })}
        >
            <button
                className="df jcb x pt2 pl2 pr2 newsletter--nav-trigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                <p className="uppercase mono--12 color--black">
                    Newsletter Sign-Up
                </p>
                <p
                    className={cx('newsletter--nav-button mono--12', {
                        active: isOpen,
                    })}
                >
                    ↑
                </p>
            </button>
            <p className="sans--12 color--black-tint mt1 pl2 pr2">
                Subscribe to receive notifications about Fenn services, product
                updates, special offers and more.
            </p>
            <form
                name="newsletter__nav"
                className="df aic jcb mobile-menu__newsletter mb2 ml2 mr2 pl1 mt2 mt0--lg mla color--black"
            >
                <label className="mobile-menu__label">
                    <input
                        type="email"
                        name="email"
                        placeholder="Email Address*"
                        className="mobile-menu__input x y pl1 mono--12  uppercase"
                        required
                        onChange={onChangeEmail}
                    />
                </label>

                <button
                    className="mobile-menu__button pl1 pr1 mono--15"
                    onClick={handleSubmit}
                >
                    →
                </button>
            </form>
            {state.isError && (
                <p className="mono--12 uppercase error mt1">{state.isError}</p>
            )}
            {state.showInvalidEmailError && (
                <p className="mono--12 uppercase error mt1">
                    Please fix your email address.
                </p>
            )}
            {state.isSuccess && (
                <p className="mono--12 uppercase mt1">{state.isSuccess}</p>
            )}
        </div>
    );
};
export default NavNewsletter;
